module.exports = __webpack_public_path__ + "static/media/C2.a01aa5f0.PNG";